/** Six publication statements; 256 KiB pages and a 30s transport deadline. */
export const replicationLimits = { maxBytes: 256 * 1024, maxRows: 64, deadlineMs: 30_000 }
export type ReplicationLimits = typeof replicationLimits

/** INV-9 admits whole transactions, so maxRows bounds the page SCAN, not its entries:
 * the opening group plus every later group starting within budget cost at most two
 * budgets, and every entry charges at least the 1,024-byte envelope allowance. */
export const maxPageEntries = Math.ceil(2 * replicationLimits.maxBytes / 1024)
